import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'
import initializers from '../../dependencies/initializers.js'



import imgHero from '../../images/hero_img_hourly.png'
import imgSectionOne from '../../images/img_hourly_01.png'
import imgSectionTwo from '../../images/img_hourly_02.png'
import imgSectionThree from '../../images/img_hourly_03.png'
import imgRoundedLeftTop from '../../images/rounded_left_top.png'

import { accesslog, translate } from '../../helpers/global.js'

import { usersGetDetailAsync } from '../../actions/users.js'
import { fetchWeeklyDemoData } from '../../helpers/fetchWeeklyDemoData.js'
import { getWeeklyDemoDataAsync } from '../../actions/global';

class Hourly extends React.Component {
	constructor(props) {
		super(props)
	}

	async componentDidMount() {
		window.scrollTo(0, 0)
		if (!this.props.weeklyDemoData || !this.props.weeklyDemoData.webinar_link) {
			await this.props.getWeeklyDemoDataAsync();
		}
	}

  chooseOpt(val) {
		const url_api = initializers.api_host
		  if(val === '1') {
			  if (process.env.NODE_ENV === 'development') {
				window.location = 'http://localhost:3000/'
			} else if (url_api == 'https://beta.astrnt.co') {
	
				window.location = 'https://test.astrnt.co/'
	
			} else {
				window.location = 'https://astrnt.co/'
			}
		  } else {
			  if (process.env.NODE_ENV === 'development') {
				window.location = 'http://localhost:3000/'
			} else if (url_api == 'https://beta.astrnt.co') {
	
				window.location = 'https://test.astrnt.id/'
	
			} else {
				window.location = 'https://astrnt.id/'
			}
		  }
		}

  render() {
    const {
      globalGetLanguages,
      user, weeklyDemoData
    } = this.props
    const renderHTML = (rawHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
    return (
			<div id="homepage">
        <HeaderNewClear isOnStatusFor="is-on" />
        <div className="banner ai">
          <section>
            <div className="ban-text apis">
              <div className="title-1">Hiring Hourly Workers at</div>
              <div className="title-1">Scale</div>
              
              <p className='sub-title-1' style={{ marginTop: '20px' }}>
                  Fast Hiring Should Still Feel Easy
                </p>

              <div className='content-desc-technical'>
                Filling frontline and hourly roles shouldn’t feel messy or rushed. ASTRNT helps you keep the process simple, consistent, and fast. Without adding more work to your team.
              </div>

              <div className={`ban-link`}>
                <Link onClick={() => {
                  document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                  accesslog('talent-acquisition/hourly', 'button_talk_to_an_expert');
                }} className="try">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</Link>
                <a href={weeklyDemoData.webinar_link} target="_blank" className="request-demo-logged"
                  onClick={() => accesslog('talent-acquisition/hourly', 'button_register_for_demo')}
                >Request for Demo</a>
              </div>
              <div className={`ban-link hide`}>
                <Link className='try'>{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</Link>
              </div>
              <a href="#" className="vid-msg">
                <img src={imgHero} />
              </a>
            </div>
          </section>
        </div>


     <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <a href="#" className="vid-msg-left-top">
            <img src={imgRoundedLeftTop} />
          </a>

          <section className='flex-container position-relative'>
            <div className='flex-item-left'>
              <div className='vertical-item--center' style={{ margin: '0 50px 0 0' }}>
                <img className='img-100' src={imgSectionOne} />
              </div>
            </div>
            
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc-point'>
                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                Why Hourly Hiring Feels <br />Chaotic
                  </h2>
                  <p className='m-b-24'>
                    Hourly and frontline roles often need to be filled quickly <br />
                    and in high numbers. But without the right tools, the <br />
                    process can be inconsistent and hard to manage.
                  </p>
                  <p style={{ fontSize: '18px' }}>{renderHTML(translate(globalGetLanguages,'TEXT_COMMON_CHALLENGES'))}</p>
                  <ul>
                    <li><i className="fa fa-circle" />Dozens of applicants with no easy way to compare</li>
                    <li><i className="fa fa-circle" />Store or outlet managers doing manual screening</li>
                    <li><i className="fa fa-circle" />Candidates often apply without CVs</li>
                    <li><i className="fa fa-circle" />No standard process across locations</li>
                    <li><i className="fa fa-circle" />Short timelines with no time for interviews</li>
                   
                  </ul>                 
                </div>
              </div>
            </div> 
          </section>
      </div>
    
    <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>            
            <div className='flex-item-right-sixty'>
              <div className='vertical-item--center'>
                <div className='sec-desc'>

                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                    Keep the Process Light, But <br />Structured
                  </h2>
                   <p style={{ fontSize: '18px' }}>
                    Hourly hiring doesn’t need to be complicated.<br />
                    With ASTRNT, you can keep things fast and easy for both <br />
                    sides—while still making sure you choose the right people.
                    </p>
                  <ul>
                    <li><i className="fas fa-check" />Candidates answer simple video questions on their <br />phone</li>
                    <li><i className="fas fa-check" />You get a consistent view of how they respond</li>
                    <li><i className="fas fa-check" />Managers can see results and make quick hiring <br />decisions</li>
                    <li><i className="fas fa-check" />No scheduling, no paperwork, no stress</li>
                  </ul>
                </div>
              </div>
            </div> 

            <div className='flex-item-left-fourty'>
              <div className='vertical-item--center'>
                <img className='img-100' src={imgSectionTwo} />
              </div>
            </div>


          </section>
      </div>

     <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>

            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionThree} />
              </div>
            </div>
            
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc'>

                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                    Suitable For All Scenarios
                  </h2>
                  <ul>
                    <li><i className="fas fa-check" />Hiring store staff for food and beverage outlets</li>
                    <li><i className="fas fa-check" />Selecting crew or helpers for warehouse operations</li>
                    <li><i className="fas fa-check" />Onboarding frontline service workers</li>
                    <li><i className="fas fa-check" />Supporting regional teams with high-volume hiring<br />needs</li>
                  </ul>
                </div>
              </div>
            </div> 
          </section>
      </div>

      <div className="section-gray single-triangle triangle-right" style={{position: 'relative'}}>
          <section className='p-t-50 p-b-50'>
            <div className='ai-interview-start'>
              <h1>Let Hiring Teams Move Faster <br />Without Guesswork</h1>
              <h4>With ASTRNT, you can make hourly hiring simpler for everyone. <br />
              It works on any device, fits into your workflow, and gives managers the confidence <br />
              they need to make fast decisions.</h4>
                <div className="ban-text-start-demo">
                <div className={`ban-link`}>
                  <Link onClick={() => {
                    document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                    accesslog('talent-acquisition/hourly', 'button_talk_to_an_expert')
                  }} className="try">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</Link>
                  <a href={weeklyDemoData.webinar_link} target="_blank" className={`request-demo-logged${weeklyDemoData.webinar_link != null ? '' : ' hide'}`}
                    onClick={() => accesslog('talent-acquisition/hourly', 'button_register_for_demo')}
                  >Register for Demo</a>
                </div>
              </div>

            </div>
          </section>
      </div>

        
        <FooterNew />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
	return {
    globalGetLanguages:state.globalGetLanguages,
    user: state.user,
    weeklyDemoData: state.weeklyDemo.weeklyDemoData 
	}
}

const mapDispatchToProps = (dispatch) => {
  return {
    usersGetDetailAsync: (user) => dispatch(usersGetDetailAsync(user)),
    getWeeklyDemoDataAsync: () => dispatch(getWeeklyDemoDataAsync())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Hourly)
